import * as React from 'react';

import { Api } from '@ClientServices/api';

import * as style from './GoToEmburse.styl';

export interface IGoToEmburseProps {
  target: '_blank' | '_self';
  autoClick?: boolean;

  // used when autoClick=false (normal use). Don't need saml response because whole saml transaction will occur
  programId?: string;

  // used when autoClick=true, doesn't need program id because response already constructed
  // see componentDidMount
  samlResponse?: string;

  acsUrl?: string;
  path: '/transactions' | '/external-accounts' | '/accounting' | '/transfers' | '/support/stolen' | '/spend/connect_account';
  label: React.ReactNode;
  relayState?: string;
}

export const componentName = 'GoToEmburse';

export class GoToEmburse extends React.Component<IGoToEmburseProps> {
  public static defaultProps = {
    relayState: ''
  };

  samlResponseInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  relayStateInputRef: React.RefObject<HTMLInputElement> = React.createRef();
  samlResponseFormRef: React.RefObject<HTMLFormElement> = React.createRef();

  handleChange(path: IGoToEmburseProps['path']) {
    Api.get(`/api/web/saml/emburse/assertion/${this.props.programId}`)
      .then((data) => data.json())
      .then((data) => {
        const base64EncodedAssertion = new Buffer(data.assertionResponse).toString('base64');

        let base64EncodedRelayState = null;
        if (path) {
          base64EncodedRelayState = new Buffer(`{"next": "${path}"}`).toString('base64');
        }

        this.submitForm(base64EncodedAssertion, base64EncodedRelayState, data.acsUrl);
      });
  }

  submitForm(assertion: string, relayState: string, acsUrl: string) {
    this.samlResponseInputRef.current.value = assertion;
    this.relayStateInputRef.current.value = relayState;
    this.samlResponseFormRef.current.action = acsUrl;
    this.samlResponseFormRef.current.submit();
  }

  componentDidMount() {
    if (this.props.autoClick) {
      this.props.samlResponse
        ? this.submitForm(this.props.samlResponse, this.props.relayState, this.props.acsUrl)
        : this.handleChange(this.props.path);
    }
  }

  render() {
    const { path, label } = this.props;
    return (
      <div className={`emburse-option ${style.global} ${this.props.autoClick ? 'hidden' : ''}`} onClick={() => this.handleChange(path)}>
        <form ref={this.samlResponseFormRef} action="" method="post" target={this.props.target}>
          <input ref={this.samlResponseInputRef} type="hidden" name="SAMLResponse" />
          <input ref={this.relayStateInputRef} type="hidden" name="RelayState" />
        </form>

        {label}
      </div>
    );
  }
}
